import { content } from '../data/content';
import { packTotal } from '../data/product';

/**
 * تحميل Firebase عند الحاجة فقط.
 *
 * المكتبة تضيف ~155KB مضغوطة، ولو استُوردت بشكل ثابت لدخلت الحزمة الرئيسية
 * وحمّلها كل زائر للصفحة الأولى — بينما لا يحتاجها إلا من وصل فعلاً إلى
 * زر تأكيد الطلب. الاستيراد الديناميكي يضعها في حزمة منفصلة.
 *
 * نداء warmFirebase عند فتح صفحة الطلب يجلبها مسبقاً فتكون جاهزة قبل الضغط.
 */
const loadFirebase = () =>
  Promise.all([import('firebase/firestore/lite'), import('./firebase')]).then(([firestore, local]) => ({
    ...firestore,
    ...local,
  }));

export function warmFirebase() {
  loadFirebase()
    .then(({ ensureSession }) => ensureSession())
    .catch(() => {
      // التهيئة المسبقة تحسين لا أكثر — فشلها لا يمنع إرسال الطلب لاحقاً
    });
}

/**
 * يحفظ الطلب في مجموعة orders ويعيد معرّفه.
 *
 * كل الأرقام تُحسب هنا وتُخزَّن مع الطلب بدل حسابها لاحقاً: لو تغيّر السعر أو
 * أجرة منطقة بعد شهر يبقى الطلب القديم محتفظاً بما دفعه الزبون فعلاً.
 */
export async function saveOrder({ form, pack, zone }) {
  const { addDoc, collection, serverTimestamp, db, ensureSession } = await loadFirebase();

  await ensureSession();

  const subtotal = packTotal(pack);

  const order = {
    product: content.orderProduct,

    packId: pack.id,
    packName: pack.name,
    qty: pack.qty,
    unitPrice: pack.unitPrice,
    subtotal,

    zoneId: zone.id,
    zoneName: zone.name,
    shipping: zone.fee,
    total: subtotal + zone.fee,

    name: form.name.trim(),
    phone: form.phone.trim(),
    address: form.address.trim(),

    // يميّز الطلبات الجديدة عن المؤكّدة عند مراجعتها في لوحة Firebase
    status: 'new',
    // وقت الخادم لا وقت جهاز الزبون — قد يكون ساعته خاطئة
    createdAt: serverTimestamp(),
  };

  const ref = await addDoc(collection(db, 'orders'), order);
  return ref.id;
}
